import { Link, NavLink, useNavigate } from "react-router-dom";
import { Clapperboard, LogOut, Film, Wand2, UserRound, Images, Wallet } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";

export const Logo = () => (
  <Link to="/" className="flex items-center gap-2.5 group" data-testid="nav-logo">
    <span className="h-8 w-8 rounded-lg bg-gradient-to-br from-[#F3D9A4] to-[#B8893F] grid place-items-center transition-transform duration-300 group-hover:rotate-6">
      <Clapperboard className="h-4 w-4 text-black" />
    </span>
    <span className="font-display text-lg tracking-tight text-white">Ar<span className="gold-text italic ml-0.5">CreativeStudio</span></span>
  </Link>
);

const appLinks = [
  { to: "/studio", label: "Estudio", icon: Wand2, id: "nav-studio" },
  { to: "/videos", label: "Mis videos", icon: Film, id: "nav-videos" },
  { to: "/galeria", label: "Galería", icon: Images, id: "nav-gallery" },
  { to: "/account", label: "Cuenta", icon: UserRound, id: "nav-account" },
  { to: "/account", label: "Añadir saldo", icon: Wallet, id: "nav-add-balance" },
];

export const Navbar = ({ landing = false }) => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <header className="sticky top-0 z-40 glass border-b border-white/5" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-16 flex items-center justify-between gap-6">
        <Logo />
        {landing ? (
          <nav className="hidden md:flex items-center gap-8 text-sm text-zinc-400">
            <a href="/funciones" className="hover:text-white transition-colors" data-testid="nav-features">Funciones</a>
            <a href="/muestras" className="hover:text-white transition-colors" data-testid="nav-samples">Muestras</a>
            <a href="/precios" className="hover:text-white transition-colors" data-testid="nav-pricing">Precios</a>
            <a href="#faq" className="hover:text-white transition-colors" data-testid="nav-faq">FAQ</a>
          </nav>
        ) : user ? (
          <nav className="flex items-center gap-1">
            {appLinks.map(({ to, label, icon: I, id }) => (
              <NavLink key={to} to={to} data-testid={id}
                className={({ isActive }) => `flex items-center gap-2 px-3 py-2 rounded-lg text-sm transition-colors ${isActive ? "bg-white/5 text-white" : "text-zinc-400 hover:text-white"}`}>
                <I className="h-4 w-4" /><span className="hidden sm:inline">{label}</span>
              </NavLink>
            ))}
          </nav>
        ) : null}
        <div className="flex items-center gap-3">
          {user ? (
            <>
              {landing && <Button data-testid="nav-open-studio" onClick={() => nav("/studio")} className="rounded-full bg-[#E8C47C] hover:bg-[#F3D9A4] text-black font-semibold">Abrir estudio</Button>}
              <span className="hidden lg:inline text-xs font-mono-tc text-[#E8C47C] border border-[#E8C47C]/30 rounded-full px-3 py-1" data-testid="nav-plan-badge">{user.plan_name}</span>
              <Button variant="ghost" size="icon" data-testid="nav-logout" onClick={async () => { await logout(); nav("/"); }}><LogOut className="h-4 w-4" /></Button>
            </>
          ) : user === false ? (
            <>
              <Link to="/login" className="text-sm text-zinc-300 hover:text-white" data-testid="nav-login">Entrar</Link>
              <Button data-testid="nav-register" onClick={() => nav("/register")} className="rounded-full bg-[#E8C47C] hover:bg-[#F3D9A4] text-black font-semibold">Probar gratis</Button>
            </>
          ) : null}
        </div>
      </div>
    </header>
  );
};
